var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"link-about"},[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("关于艺爪")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }